// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-js": () => import("C:\\OSPanel\\domains\\gatsby-si\\src\\templates\\page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-pages-404-js": () => import("C:\\OSPanel\\domains\\gatsby-si\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

